import { TweenMax } from 'gsap';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import { IOverlayData, OverlayType } from '../../../vendor_core/core/src/server/data/ISpinData';
import { State } from '../../../vendor_core/core/src/states/State';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import PromiseHelpers from '../../../vendor_core/core/src/utils/PromiseHelpers';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import BBAnimationsHelper from '../utils/BBAnimationsHelper';
import BBReelGroup from '../view/BBReelGroup';

export default class BBMoveSymbolState extends State {
    public enter(): void {
        super.enter();
        this.playAnimations();

    }

    protected playTornadoAnimations = () => {
        BBAnimationsHelper.playTornadoAnimations(() => {
            ViewManager.getLayer("Tornado").clear();
        })
    }
    protected playAnimations() {
        this.playWalking();
        SoundController.playSound('wild_movement_big');
        TweenMax.delayedCall(0.3, () => {
            this.exit()
        })
    }

    protected playWalking(): Promise<boolean> {
        let overlays: IOverlayData[] = [];
        if (SpinModel.hasOverlay(OverlayType.Moving)) {
            overlays.push(...SpinModel.getOverlays(OverlayType.Moving))
        }
        let promises = [];
        const scene = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as BBReelGroup;
        let positions = [
            {
                reel: 3,
                row: 4
            },
            {
                reel: 4,
                row: 3
            },
            {
                reel: 3,
                row: 3
            },

        ]
        overlays.forEach(overlay => {
            promises.push(reelGroup.winSymbolsView.moveSpineSymbolsToCenter(overlay, positions));
        });

        return PromiseHelpers.combineParallel(promises);
    }

}
